import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { SessionCookieService } from '@app/core/cookies';
import { MatDialog } from '@angular/material/dialog';
import { FeatureGuard } from '@app/shared/guards/feature-guard.service';
import { Store } from '@ngrx/store';
import { IAppState } from '@app/store';

@Injectable({
  providedIn: 'root'
})
export class ChatGuard extends FeatureGuard {
  featureName = 'chat';

  constructor(
    protected sessionService: SessionCookieService,
    protected router: Router,
    protected dialog: MatDialog,
    protected store: Store<IAppState>
  ) {
    super(sessionService, router, dialog, store);
  }
}
